import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Stethoscope, UserRound, Bot } from 'lucide-react';
import './Landing.css';

const Landing = () => {
  return (
    <div className="landing">
      {/* Background decoration */}
      <div className="landing-bg-grid" aria-hidden="true" />

      <div className="landing-content">
        <div className="landing-left">
          <div className="landing-badge">
            <span className="badge-dot" />
            AI-Powered Medical Education
          </div>

          <h1 className="landing-title">
            Apollo<br />
            <span className="landing-title-accent">Medical AI</span>
          </h1>

          <p className="landing-description">
            An advanced educational platform for simulated clinical interactions, 
            diagnostic reasoning, and AI-assisted decision support.
          </p>

          <Link to="/login" className="landing-cta">
            Get Started
            <ArrowRight size={18} />
          </Link>

          <div className="landing-features">
            <div className="landing-feature">
              <div className="feature-icon">
                <Stethoscope size={16} />
              </div>
              <span>Doctor Simulation</span>
            </div>
            <div className="landing-feature">
              <div className="feature-icon">
                <UserRound size={16} />
              </div>
              <span>Patient Interaction</span>
            </div>
            <div className="landing-feature">
              <div className="feature-icon">
                <Bot size={16} />
              </div>
              <span>Clinical Copilot</span>
            </div>
          </div>
        </div>

        <div className="landing-right">
          <div className="landing-logo-container">
            <div className="landing-logo-glow" />
            <img
              src="/ApolloLogo.png"
              alt="Apollo Medical AI"
              className="landing-logo-img"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="landing-logo-fallback" style={{ display: 'none' }}>
              <Stethoscope size={64} />
            </div>
          </div>
        </div>
      </div>

      <footer className="landing-footer">
        <span>Built for medical education &amp; research</span>
      </footer>
    </div>
  );
};

export default Landing;
